import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';

import he from './locales/he.json';

const options = {
  resources: {
    he: {
      translation: he,
    },
    en: {
      translation: en,
    },
  },
  fallbackLng: 'en',
};

i18n.use(initReactI18next).init(options);

export default i18n;
